const Invoice = {

    // FIELDS
    "customer": "العميل",
    "delivery_note": "مذكرة التسليم",
    "date": "التاريخ",
    "search": "بحث",
    "item": "العنصر",
    "rate": "السعر",
    "quantity": "الكمية",
    "unit": "الوحدة",
    "vat": "ضريبة القيمة المضافة (%)",
    "sub_total": "المجموع الفرعي",
    "discount": "الخصم (%)",
    "remark": "ملاحظات",
    "total": "المجموع",

    // PAGE HEADER
    "invoice": "الفاتورة",

    // TOOLTIP
    "payment": "الدفع",
    "history": "التاريخ",

    // ERROR
    "error_customer": "اختر العميل",
    "error_delivery_note": "اختر مذكرة التسليم",
    "error_date": "اختر التاريخ",

    // TABLE HEADER
    "table_invoice_code": "رمز الفاتورة",
    "table_customer": "العميل",
    "table_date": "التاريخ",

}

export default Invoice;